"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingMessageForm = void 0;
var React = require("react");
var moment = require("moment");
var stateless_forms_1 = require("../forms/stateless_forms");
var buttons_1 = require("../../buttons");
function getNewMessage(booking_id, user, message) {
    return {
        id: 0,
        booking: booking_id,
        author_user_id: user.id,
        author_name: user.full_name + (user.company ? " (" + user.company + ")" : ""),
        date: moment(),
        comment: message,
    };
}
var BookingMessageForm = function (_a) {
    var booking = _a.booking, user = _a.user, bookingMessageSvc = _a.bookingMessageSvc, cancel_new = _a.cancel_new;
    var _b = __read(React.useState(""), 2), new_message = _b[0], setMessage = _b[1];
    var fields = [
        {
            name: "comment",
            label: gettext("Message"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXTAREA,
            value: new_message,
            required: true,
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col" },
                React.createElement(stateless_forms_1.SimpleForm, { fields: fields, onUpdate: function (name, value) {
                        setMessage(value);
                    }, valuesObject: {} }))),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col text-right" },
                React.createElement(buttons_1.Button, { onClick: function () {
                        bookingMessageSvc.create(getNewMessage(booking.id, user, new_message));
                        cancel_new();
                    }, className: "btn-sm" }, gettext("Send")),
                " ",
                React.createElement(buttons_1.Button, { onClick: cancel_new, className: "btn-sm" }, gettext("Cancel"))))));
};
exports.BookingMessageForm = BookingMessageForm;
